import axios from "axios";
import {AKENEO_API_URL} from "@/common/config";

function init() {
    return axios.create({
        baseURL: AKENEO_API_URL,
        //timeout: 10000
    });
};

const Api = {
    get(resource, params = null) {
        return init().get(resource, params)/*.catch(error => {
            throw new Error(`ApiService ${error}`);
        })*/
    },
    download(resource, params = null) {
        return init()({
            method: 'GET',
            url: resource,
            params: params,
            responseType: 'blob',
        });
    },

    post(resource, postDatas, params = null) {
        return init().post(`${resource}`, postDatas, params);
    },
};

export default Api;